import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

import Header from './components/Header';
import RegistrationForm from './components/RegistrationForm';
import PaymentResult from './components/PaymentResult';
import PaynimoResult from './components/PaynimoResult';
import AdminPage from './pages/AdminPage';
import AdminLogin from './components/AdminLogin';

// Protected route component for admin access
const ProtectedAdminRoute = ({ children }) => {
  const isAuthenticated = sessionStorage.getItem('adminAuth') !== null;
  
  if (!isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }
  
  return children;
};

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main className="min-vh-100">
          <Routes>
            <Route path="/" element={<RegistrationForm />} />
            <Route path="/payment-result" element={<PaymentResult />} />
            <Route path="/paynimo-result" element={<PaynimoResult />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={
              <ProtectedAdminRoute>
                <AdminPage />
              </ProtectedAdminRoute>
            } />
          </Routes>
        </main>
        
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </Router>
  );
}

export default App;
